import ApexChart from 'components/ui/StockChart/stockChartApex';
import { addCommas } from 'utils/shared';
import MarketCap from './MarketCap';

const durations = [
  // { label: '1 min', value: '1 min' },
  // { label: '5 min', value: '5 min' },
  // { label: '15 min', value: '15 min' },
  { label: '1 hr', value: '1h' },
  { label: '4 hr', value: '4h' },
  { label: '1 day', value: '1d' },
  { label: '1 month', value: '1mo' },
  { label: '1 year', value: '1y' },
];

const YieldCurve = ({ historicData, marketCap, handleMarkupClick, selectedMarkup, handleHistoryPayload, historyPayload }) => {
  const handleDurationClick = (value) => {
    handleHistoryPayload("period" , value);
  };

  return (
    <div className='bg-white rounded-xl pt-4'>
      <div className='flex flex-col md:flex-row gap-10 md:gap-0'>
        <div className='w-full md:w-[70%]'>
          <div className='flex justify-between items-center px-5 pb-4 border-b-[1px]'>
            <div className='text-xl font-bold'>Yield Curve Analysis</div>
            <div className=' rounded-lg w-fit bg-[#006CFF] text-white px-5 py-1 cursor-pointer'>BUY</div>
          </div>
          <div className='flex justify-between px-5 py-[14px] border-b-[1px] w-full'>
            <div className='text-sm md:text-lg'>${addCommas(selectedMarkup?.market_cap)}</div>
            <div className='flex items-center text-[#EE2E6B] text-sm gap-2 md:gap-5'>
              <div className={selectedMarkup?.day_change_percent > 0 ? 'text-seaGreen' : 'text-[#EE2E6B]'}>{selectedMarkup?.day_change_percent?.toFixed(2)}%</div>
              <div>
                <img src={selectedMarkup?.day_change_percent > 0 ? '/img/Shape.svg' : '/img/down.png'} alt='' /></div>
            </div>
            <div className='flex items-center text-sm gap-2 md:gap-5'>
              <div className='text-[#969799]'>High</div>
              <div className='text-sm font-medium'>{historicData?.[0]?.high?.toFixed(2)}</div>
            </div>
            <div className='flex items-center text-sm gap-2 md:gap-5' >
              <div className='text-[#969799]'>Low</div>
              <div className='font-medium'>{historicData?.[0]?.low?.toFixed(2)}</div>
            </div>
            <div className='flex items-center text-sm gap-2 md:gap-5'>
              <div className='text-[#969799]'>24h Volume</div>
              <div className='font-medium'>{historicData?.[0]?.vol}</div>
            </div>
            <div className='flex items-center text-sm gap-2 md:gap-5' >
              <div className='text-[#969799]'>Price Alert</div>
              <div><img src='/img/alert.svg' alt='' /></div>
            </div>
          </div>
          <div className='flex gap-6 text-sm text-lightGrey pl-4 py-2'>
            {durations.map((duration) => (
              <div
                key={duration.value}
                className={`cursor-pointer px-2 ${historyPayload?.period === duration.value
                  ? 'border-b-2 border-b-seaGreen'
                  : ''
                  }`}
                onClick={() => handleDurationClick(duration.value)}
              >
                {duration.label}
              </div>
            ))}
          </div>
          <ApexChart historicData={historicData} />
        </div>
        <div className='w-full border-t-2 md:border-t-0 md:border-l-2 md:w-[30%]'><MarketCap marketCap={marketCap} handleMarkupClick={handleMarkupClick} /></div>
      </div>
    </div>
  )
}

export default YieldCurve